<template>
<body>
    <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
    <div @click="mixNav()" class="burgerHeader">
      <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
    </div>
    <div class="burgerBody">
      <nav>
        <ul class="topMenu">
          <li class="active">
            <a href="#" target="_self">
              Home
            </a>
          </li>
          <li class=" ">
            <router-link to="/shop" target="_self">
              Shop
            </router-link>
          </li>
          <li class=" ">
            <router-link to="/user/account" target="_self">
              Account
            </router-link>
          </li>
          <li class="">
              <router-link to="/how-it-works" target="_self">
                How It Works
              </router-link>
            </li>
        </ul>
      </nav>
    </div>
    <div class="burgerBot">
      <p>supremeaccess | Legal | Disclousure</p>
    </div>
  </div>
  <div class="flexLayoutShop">
    <div class="leftSidebar">
      <div class="logoContainer">
        <a href="#"><img src="../../../assets/images/logo-white.svg" alt="" /></a>
      </div>
      <section class="sidebarBot">
        <div class="sideBotBod">
          <div class="sideBotFlexMenu">
            <li><a href="#">Home</a></li>
            <li><a href="#">Shop</a></li>
            <li class="active"><a href="#">Account</a></li>
          </div>
          <div class="sidePageTitle">
            <h1>Account</h1>
          </div>
        </div>
      </section>
    </div>
    <div class="flexLayoutBody">
      <span class="pageTitleOnMobile">Account</span>
      <div class="cartSidebar">
        <a href="#" class="closeSidebar"><i class="far fa-times"></i></a>
        <h2>Cart</h2>
        <h2>Select Profile</h2>
        <h2>Order Review</h2>
        <h2>Order Review</h2>
        <div class="itemsInCartGrid">
          <div class="indivItemInCart">
            <div class="itemImg">
              <img src="../../../assets/images/lvs.png" alt="" />
            </div>
            <div class="itemInfo">
              <h4>Supreme Backpack</h4>
              <p>Size L</p>
              <a href="#"><i class="far fa-trash"></i></a>
            </div>
          </div>
          <div class="differentProfilesContainer">
            <div class="individProfile mainProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
            <hr />
            <div class="individProfile">
              <h6>John Doe (Main Account)</h6>
              <div class="individInfoP">
                <p>123 Fake Street</p>
                <p>New York, NY 00000</p>
              </div>
            </div>
          </div>
          <div class="orderReviewContainer">
            <div class="individualInput">
              <h4>Coupon</h4>
              <input type="text" name="" id="" value="freesupreme" />
              <span class="percentOff">
                -$150
              </span>
            </div>
            <div class="individualInput">
              <h4>Items (3)</h4>
              <div class="gridListOfInput">
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
                <div class="individGridList">
                  <h5>Supreme Backpack</h5>
                  <h5>Size L</h5>
                  <h6>$100</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="fixedBottomSidebar">
            <div class="totalsContainer">
              <h5>Total:</h5>
              <h5>$150</h5>
            </div>
            <a href="#">Checkout</a>
          </div>
        </div>
      </div>
      <div class="mobileNavTop">
        <a @click="mixNav" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
        <div class="logoContainerMobile">
          <a href="#"><img src="../../../assets/images/logo-white.svg" alt="" /></a>
        </div>
        <a href="#" class="iconCartMobile openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
      </div>
      <div class="flexLayoutTop">
        <div class="flexLayoutShopFilter">
          <nav class="flexLayoutShopFilterActual">
            <li><a href="#">Account Info</a></li>
            <li><a href="#">Personas</a></li>
            <li class="active"><a href="#">Orders</a></li>
            <li><a href="#">Sign Out</a></li>
          </nav>
        </div>
        <div class="flexLayoutTopRight">
          <a href="#" class="openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
        </div>
      </div>
      <div class="flexLayoutActualBody">
        <div class="userInfoInAccountContainer">
          <div class="itemBodyLeftModal notModal notModalOrderTrack">
            <div class="leftSideNotMdl">
              <div class="trackContainer">
                <h2>Order #1739</h2>
                <p>
                  To track your order please enter your Order ID in the box
                  below and press the "Track" button. This was given to you on
                  your receipt and in the confirmation email you should have
                  received.
                </p>
                <div class="individualInput">
                  <h5>Date</h5>
                  <input type="text" name="" id="" placeholder="" value="November 1, 1972" />
                </div>
                <div class="individualInput">
                  <h5>Status</h5>
                  <input type="text" name="" id="" placeholder="" value="Refunded" />
                </div>
                <div class="individualInput">
                  <h5>Items</h5>
                  <input type="text" name="" id="" placeholder="" value="4" />
                </div>
              </div>
              <div class="quickCheckout">
                <a href="#">View Another Order</a>
              </div>
            </div>

            <div class="rightSideOrderTracker">
              <div class="differentProfilesContainer">
                <div class="orderReviewContainer">
                  <div class="individualInput">
                    <h4>Persona Used</h4>
                    <div class="individProfile">
                      <h6>John Doe (Main Account)</h6>
                      <div class="individInfoP">
                        <p>123 Fake Street</p>
                        <p>New York, NY 00000</p>
                      </div>
                    </div>
                  </div>
                  <div class="individualInput">
                    <h4>Coupon</h4>
                    <input type="text" name="" id="" value="freesupreme" />
                    <span class="percentOff" style="color: #fff;">
                      -$150
                    </span>
                  </div>
                  <div class="individualInput">
                    <h4>Items (3)</h4>
                    <div class="gridListOfInput" style="max-height: 100%;">
                      <div class="individGridList">
                        <h5>Supreme Backpack</h5>
                        <h5>Size L</h5>
                        <h6>$100</h6>
                      </div>
                      <div class="individGridList">
                        <h5>Supreme Backpack</h5>
                        <h5>Size L</h5>
                        <h6>$100</h6>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="totalCostContainer">
                    <h5>Total:</h5>
                    <h5>$150</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</template>
<script>
import states from '@/helpers/states'
export default {
  data() {
    return {
        showNav: false
    }
  },
  methods: {
    mixNav() {
        this.showNav = !this.showNav;
    }
  }
}
</script>